<h2 mat-dialog-title>Edit Result</h2>

<form [formGroup]="nationalGameForm">
  <div mat-dialog-content>
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
      <mat-form-field appearance="outline" style="width: 45%;">
        <mat-label>Home Team Score</mat-label>
        <input formControlName="homeTeamScore" [min]="0" matInput placeholder="0" type="number"/>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%;">
        <mat-label>Away Team Score</mat-label>
        <input formControlName="awayTeamScore" [min]="0" matInput placeholder="0" type="number"/>
      </mat-form-field>
    </div>


    <div mat-dialog-actions style="display: flex; justify-content: space-around">
      <button (click)="cancel()" color="primary" mat-raised-button>Cancel</button>
      <button (click)="saveGame()" color="primary" mat-raised-button>
        Update Result
      </button>
    </div>
  </div>
</form>
